module.exports = {
	name: 'percentage',
	validation(yup) {
		return yup.number().max(100);
	}
};
